import { useUser } from "@clerk/clerk-react";
import { SafeAreaView, ScrollView, TouchableOpacity, View } from "react-native";
import { usePostHog } from "posthog-js/react";
import { useState } from "react";
import TicketDialog from "../components/feature/support/ticket-dialog";
import StyledText from "../components/common/ui/styled-text";
import { FileText, Mail, MessageSquare } from "lucide-react-native";

const SupportTab = () => {
  const { user } = useUser();
  const posthog = usePostHog();
  const [isTicketDialogOpen, setIsTicketDialogOpen] = useState(false);

  const handlePhoneSupport = () => {
    posthog.capture("support_phone");
    window.open("tel:+17372629549", "_blank");
  };

  const handleChatSupport = () => {
    posthog.capture("support_chat");
    const email = user?.emailAddresses[0]?.emailAddress;
    if (typeof window !== "undefined" && window.$crisp) {
      window.$crisp.push(["set", "user:email", email]);
      window.$crisp.push(["do", "chat:open"]);
    }
  };

  const handleTicketSupport = () => {
    posthog.capture("support_ticket");
    setIsTicketDialogOpen(true);
  };

  const handleEmailSupport = () => {
    posthog.capture("support_email");
    window.open("mailto:support@loman.ai", "_blank");
  };

  return (
    <SafeAreaView className="flex-1 bg-gray-50">
      <ScrollView>
        <View className="container px-4 py-8 gap-4 md:px-6 md:py-12 lg:py-16 mx-auto pb-20">
          <View className="mx-auto max-w-4xl">
            <StyledText className="text-2xl sm:text-4xl md:text-5xl font-bold tracking-tight text-center">
              How can we help you today?
            </StyledText>
            <StyledText className="mt-2 text-muted-foreground md:text-xl text-center">
              Choose from our support options below
            </StyledText>
          </View>
          <View className="p-4 flex flex-col md:flex-row flex-wrap justify-center gap-8">
            {/* Live Chat Card */}
            <View className="w-full md:flex-1 md:max-w-sm bg-white rounded-xl p-4 shadow-md flex-col justify-between">
              <View className="mb-3">
                <View className="w-12 h-12 rounded-full bg-blue-100 items-center justify-center mb-3">
                  <MessageSquare size={24} color="#3b82f6" />
                </View>
                <StyledText className="text-xl font-bold mb-1">
                  Live Chat
                </StyledText>
                <StyledText className="text-gray-500 text-sm">
                  Chat with our support team in real-time. Connect through our
                  live chat service.
                </StyledText>
              </View>

              <TouchableOpacity
                className="bg-white border border-blue-500 rounded-lg py-3 px-4 flex-row items-center justify-center"
                onPress={handleChatSupport}
              >
                <MessageSquare size={16} color="#3b82f6" className="mr-2" />
                <StyledText className="text-blue-500 font-semibold text-base">
                  Start Chat
                </StyledText>
              </TouchableOpacity>
            </View>

            {/* Support Ticket Card */}
            <View className="w-full md:flex-1 md:max-w-sm bg-white rounded-xl p-4 shadow-md flex-col justify-between">
              <View className="mb-3">
                <View className="w-12 h-12 rounded-full bg-blue-100 items-center justify-center mb-3">
                  <FileText size={24} color="#3b82f6" />
                </View>
                <StyledText className="text-xl font-bold mb-1">
                  Support Ticket
                </StyledText>
                <StyledText className="text-gray-500 text-sm">
                  Submit a ticket for non-urgent issues. Create a support ticket
                  and our team will respond as soon as possible.
                </StyledText>
              </View>

              <TouchableOpacity
                className="bg-white border border-blue-500 rounded-lg py-3 px-4 flex-row items-center justify-center"
                onPress={handleTicketSupport}
              >
                <FileText size={16} color="#3b82f6" className="mr-2" />
                <StyledText className="text-blue-500 font-semibold text-base">
                  Submit Ticket
                </StyledText>
              </TouchableOpacity>
            </View>

            {/* Email Support Card */}
            <View className="w-full md:flex-1 md:max-w-sm bg-white rounded-xl p-4 shadow-md flex-col justify-between">
              <View className="mb-3">
                <View className="w-12 h-12 rounded-full bg-blue-100 items-center justify-center mb-3">
                  <Mail size={24} color="#3b82f6" />
                </View>
                <StyledText className="text-xl font-bold mb-1">
                  Email Support
                </StyledText>
                <StyledText className="text-gray-500 text-sm">
                  Send us an email to support@loman.ai and we'll get back to you
                  as soon as possible.
                </StyledText>
              </View>

              <TouchableOpacity
                className="bg-white border border-blue-500 rounded-lg py-3 px-4 flex-row items-center justify-center"
                onPress={handleEmailSupport}
              >
                <Mail size={16} color="#3b82f6" className="mr-2" />
                <StyledText className="text-blue-500 font-semibold text-base">
                  Email Us
                </StyledText>
              </TouchableOpacity>
            </View>

            {/* Urgent Support Card */}
            {/* {isMobile && (
              <View className="w-full md:flex-1 md:max-w-sm bg-white rounded-xl p-4 shadow-md flex-col justify-between">
                <View className="mb-3">
                  <View className="w-12 h-12 rounded-full bg-blue-100 items-center justify-center mb-3">
                    <Feather name="phone-call" size={24} color="#3b82f6" />
                  </View>
                  <StyledText className="text-lg font-bold mb-1">
                    Call Support
                  </StyledText>
                  <StyledText className="text-gray-500 text-sm">
                    If you prefer a phone call, call our support team.
                  </StyledText>
                </View>

                <TouchableOpacity
                  className="bg-white border border-blue-500 rounded-lg py-3 px-4 flex-row items-center justify-center"
                  onPress={handlePhoneSupport}
                >
                  <Feather
                    name="phone-call"
                    size={16}
                    color="#3b82f6"
                    className="mr-2"
                  />
                  <StyledText className="text-blue-500 font-semibold text-base">
                    Call Support
                  </StyledText>
                </TouchableOpacity>
              </View>
            )} */}
          </View>
        </View>
      </ScrollView>

      <TicketDialog
        open={isTicketDialogOpen}
        onOpenChange={setIsTicketDialogOpen}
      />
    </SafeAreaView>
  );
};

export default SupportTab;
